import { render, staticRenderFns } from "./consumableSurplusWithMajor.vue?vue&type=template&id=456b9c60&scoped=true"
import script from "./consumableSurplusWithMajor.vue?vue&type=script&lang=js"
export * from "./consumableSurplusWithMajor.vue?vue&type=script&lang=js"
import style0 from "./consumableSurplusWithMajor.vue?vue&type=style&index=0&id=456b9c60&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456b9c60",
  null
  
)

export default component.exports